import SearchBar from "@/components/base/SearchBar";

interface HeroSectionProps {
  onSearch: (keyword: string) => void;
}

export default function HeroSection({ onSearch }: HeroSectionProps) {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20navy%20blue%20background%20with%20subtle%20silhouettes%20of%20scales%20of%20justice%2C%20classical%20law%20columns%20and%20flowing%20geometric%20line%20patterns%2C%20soft%20golden%20light%20accents%2C%20authoritative%20professional%20legal%20portal%20atmosphere%2C%20wide%20cinematic%20composition%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=hero-home-2026a&orientation=landscape"
        alt="法律与伦理知识门户背景"
        title="乱伦法律与伦理专题门户"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-950/70 to-primary-900/85" />
      <div className="relative z-10 mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs tracking-wide text-background-100 backdrop-blur">
          <i className="ri-shield-check-line text-accent-300" />
          法律 · 伦理 · 社会规范
        </span>
        <h1 className="max-w-4xl text-3xl font-black leading-tight text-background-50 md:text-5xl">
          乱伦法律与伦理专题
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
          系统梳理近亲性关系相关的法律法规、伦理道德与社会规范，帮助公众、法律从业者与研究者准确理解法律界限，
          提升法律意识与道德认知，避免误解与误用。
        </p>

        <div className="mt-8 w-full max-w-2xl">
          <SearchBar size="lg" onSearch={onSearch} />
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-background-100/75">
          <span className="flex items-center gap-1.5">
            <i className="ri-file-list-3-line text-accent-300" />
            法规条文与司法解读
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-scales-3-line text-accent-300" />
            伦理框架理性分析
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-folder-shield-2-line text-accent-300" />
            虚构案例教学演示
          </span>
        </div>
      </div>
    </section>
  );
}